export default __webpack_public_path__ + "resources/icons/n210-bc63.webp";